import { logError as logDataDogError } from './datadog';

const appUrl = process.env.CARVANA_APP_PUBLIC_URL || '';
const isLocalDevEnvironment = appUrl.includes('localhost');

const logError = (error: Error & { context?: unknown }) => {
  if (isLocalDevEnvironment) {
    // eslint-disable-next-line no-console
    console.error({
      stack: error.stack,
      context: error.context,
      message: error.message
    });
  } else {
    logDataDogError(error);
  }
};

export default logError;
